<template>
	<div class="workflow-container-product-wrap" :class="{'workflow-container-custom-content': hasCustomProduct}">
		<div class="workflow-container-body" :class="{'is-custom-product': hasCustomProduct}">
			<!-- Is Custom Product -->
			<template v-if="hasCustomProduct">
				<CustomProduct
					class="wf-body-column"
					:customContent="product.customContent"
					:stepInfo="{name: product.name, key: product.key}"
					:isLabNotesActive="isLabNotesActive"
					@removeProduct="removeProduct"
				/>
			</template>

			<!-- Is Qiagin Product -->
			<template v-else>
				<!-- product image -->
				<ProductImage
					class="wf-body-column"
					:src="{image: product.image, mobileImage: product.mobileImage, imageKey: product.key}"
					:alt="product.name[getLang]"
					:key="product.key"
					:class="{'lab-note-image': isLabNotesActive}"
					:stepNumber="stepNumber"
				/>
				<!-- product name/description -->
				<ProductContent
					class="wf-body-column"
					:country="country"
					:product="product"
					:lang="getLang"
					:isLabNotesActive="isLabNotesActive"
					:isGeneGlobe="isGeneGlobe"
					@removeProduct="removeProduct"
					v-on="$listeners"
					:data-test="`product-${product.catalogNumber}`"
				/>
			</template>

			<!-- launch options modal desktop -->
			<ProductOptions
				v-if="!isLabNotesActive"
				class="wf-body-column"
				:isRequired="isRequired"
				:productsCount="productsCount"
				:tourActive="tourActive"
				:isTabletView="isTabletView"
				@removeProduct="removeProduct"
				@seeAllProducts="seeAllProducts"
			/>
		</div>
		<!-- launch options modal mobile/tablet -->
		<ProductBtnTablet
			v-if="!isLabNotesActive && !isRequired"
			:productsCount="productsCount"
			:tourActive="tourActive"
			:isTabletView="isTabletView"
			v-on="$listeners"
		/>
		<GeneGlobe v-if="!isLabNotesActive && isGeneGlobe" v-on="$listeners" :articleNumber="product.articleNumber" />
	</div>
</template>
<script>
import {trackEvent} from '@/services/tracking.js';
import CustomProduct from './CustomProduct.vue';
import GeneGlobe from './GeneGlobe.vue';
import ProductBtnTablet from './ProductBtnTablet.vue';
import ProductContent from './ProductContent.vue';
import ProductImage from './ProductImage.vue';
import ProductOptions from './ProductOptions.vue';

export default {
	name: 'Product',
	components: {
		CustomProduct,
		GeneGlobe,
		ProductBtnTablet,
		ProductContent,
		ProductImage,
		ProductOptions,
	},
	props: {
		country: {
			type: String,
		},
		product: {
			type: Object,
		},
		productsCount: {
			type: Number,
		},
		isLabNotesActive: {
			type: Boolean,
		},
		stepName: {
			type: String,
		},
		stepNumber: {
			type: Number,
		},
		tourActive: {
			type: Boolean,
			default: false,
		},
		isTabletView: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			requiredBy: null,
		};
	},
	watch: {
		product: {
			deep: true,
			immediate: true,
			handler() {
				this.requiredBy = !!this.product?.rules?.requiredBy?.size;
			},
		},
	},
	methods: {
		removeProduct() {
			// create emittable object
			const args = {stepName: this.stepName, name: null, key: this.product.key, blocked: null};

			if (this.product?.rules) {
				const {
					rules: {exclusiveRequiredBy, requiredBy},
					name,
				} = this.product;
				// set name of product
				args.name = name[this.$store.state.LANG];

				// blocking products from being removed if they are required
				if (exclusiveRequiredBy.size > 0 || requiredBy.size > 0)
					args.blocked = new Set([...exclusiveRequiredBy, ...requiredBy]);
			}
			// emit to modal
			this.$root.$emit('removeProduct', args);
		},
		seeAllProducts() {
			trackEvent('ctaClick', {eVar58: 'See All Products | Workflow Configurator'});
			this.$emit('seeAllProducts');
		},
	},
	computed: {
		getLang() {
			return this.$store.state.LANG || 'enUS';
		},
		hasCustomProduct() {
			return !!this.product.customContent;
		},

		isGeneGlobe() {
			return this.product.itemType == 'GeneGlobe';
		},
		isRequired() {
			return this.requiredBy;
		},
	},
};
</script>
<style lang="scss">
.workflow-container-product-wrap {
	.workflow-container-body {
		/* REMOVE PRODUCT */
		.remove-product {
			background-color: $color-light-grey;
			color: $color-grey;
			transition: opacity 0.3s ease;
			z-index: 6;
			i {
				transform: rotate(45deg);
			}
			&.tablet {
				margin: 0 0 8px auto;
				display: block;
				@media (min-width: $tablet + 1) {
					display: none;
				}
			}
			&.mobile {
				@media (min-width: $mobile + 1) {
					display: none;
				}
			}
		}
	}
}
</style>
